import {useEffect} from 'react';
import {logEvent} from './db';
// Count visible, recently interactive time only; never count generation or idle tabs.
export function useLearningTime(learnerId:string|undefined,topic:string,enabled=true){
  useEffect(()=>{
    if(!learnerId||!enabled)return;
    let seconds=0;let last=Date.now(),interaction=Date.now();
    const touch=()=>{interaction=Date.now();};
    const flush=()=>{const n=Math.floor(seconds);if(!n)return;seconds-=n;void logEvent(learnerId,'active_learning_time',{seconds:n,topic}).catch(()=>{seconds+=n;});};
    const timer=setInterval(()=>{const now=Date.now();if(document.visibilityState==='visible'&&now-interaction<60000)seconds+=Math.min(5,(now-last)/1000);last=now;if(seconds>=30)flush();},5000);
    const visibility=()=>{last=Date.now();if(document.visibilityState==='hidden')flush();};
    window.addEventListener('pointerdown',touch);window.addEventListener('keydown',touch);window.addEventListener('scroll',touch);document.addEventListener('visibilitychange',visibility);
    return()=>{clearInterval(timer);flush();window.removeEventListener('pointerdown',touch);window.removeEventListener('keydown',touch);window.removeEventListener('scroll',touch);document.removeEventListener('visibilitychange',visibility);};
  },[learnerId,topic,enabled]);
}
